import { createAction } from 'redux-actions';

export const actionTypes = {
    GET_LIST: 'admin/GET_LIST',
    GET_ROLE_LIST: 'admin/GET_ROLE_LIST',
    GET_DETAIL: 'admin/GET_DETAIL',
    CREATE: 'admin/CREATE',
    UPDATE: 'admin/UPDATE',
    UPDATE_STATUS: 'admin/UPDATE_STATUS',
    GET_LIST_APP: 'admin/GET_LIST_APP',
    GET_APP_ASSIGNED: 'admin/GET_APP_ASSIGNED',
    ASSIGN_APP: 'admin/ASSIGN_APP',
}

export const actions = {
    getList: createAction(actionTypes.GET_LIST),
    getRoleList: createAction(actionTypes.GET_ROLE_LIST),
    getDetail: createAction(actionTypes.GET_DETAIL),
    create: createAction(actionTypes.CREATE),
    update: createAction(actionTypes.UPDATE),
    updateStatus: createAction(actionTypes.UPDATE_STATUS),
    getListApp: createAction(actionTypes.GET_LIST_APP),
    getAppAssigned: createAction(actionTypes.GET_APP_ASSIGNED),
    assignApp: createAction(actionTypes.ASSIGN_APP),
}

